import React from 'react';
import styled from 'styled-components';
import { Breakpoints, Grid, Type } from '../../app/StyleGuide';
import { WhiteButton } from '../../components/Buttons';
import { Container } from '../../components/Layout';
import LoadingState from '../../components/LoadingState';
import { useAcceptEasyLink } from './hooks/useAcceptEasyLink';

const InviteContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @media (min-width: ${Breakpoints.screen_xs}) {
    flex-direction: column;
    padding: ${Grid._10} ${Grid._5} 0;
  }
`;

const ErrorMessage = styled.h2`
  font-weight: ${Type.Weight.normal};
  font-size: ${Type.Scale._4};
  margin-bottom: ${Grid._6};
`;

export const AcceptEasyLink = () => {
  const { isLoading, errorHeader, errorMessage, redirectHashAndSyncWhiteLabel, errorButtonText } = useAcceptEasyLink();
  return (
    <InviteContainer>
      {isLoading ? (
        <LoadingState />
      ) : (
        <>
          <h2>{errorHeader}</h2>
          <ErrorMessage>{errorMessage}</ErrorMessage>
          <WhiteButton onClick={redirectHashAndSyncWhiteLabel}>{errorButtonText}</WhiteButton>
        </>
      )}
    </InviteContainer>
  );
};
